var map = {
	"./icons/shape.svg": "ffd7",
	"./icons/sprite.svg": "087d",
	"./image-admin/welcome-admin.svg": "c25c",
	"./image-global/avatar.png": "0285",
	"./image-global/back-sidebar.jpg": "beee",
	"./image-global/item.png": "30bd",
	"./image-global/page-not-found.svg": "db4d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e107";